define('core/views/FacebookPhotoRichMediaView',[
    'core/views/ImageRichMediaView',
], function (
    ImageRichMediaView
) {
    'use strict';

    return ImageRichMediaView.extend({
        getImageThumbnailUrl: function () {
            // If possible, use the larger image that Facebook provides
            return this.media.get('metadata').imageUrl ||
                ImageRichMediaView.prototype.getImageThumbnailUrl.call(this);
        },
    });
});

